<template src="./ButtonExportBillComponent.html"></template>
<script>
export default {
  name: 'ButtonExportBillComponent',
  props: {
    label: {
      type: String,
      required: false,
      default: () => ''
    }
  },
  data() {
    return {}
  }
}
</script>
<style lang="scss">
  .btn-search {
    padding: 6px 10px;
  }
</style>
